// /src/pages/ContactPage.jsx

import React from 'react';
import PublicLexicalPage from '../components/PublicLexicalPage';

function ContactPage() {
  const documentName = 'contact';
  return <PublicLexicalPage documentName={documentName} />;
}

export default ContactPage;
